import { gql } from '@apollo/client';

export const READ_NOTIFICATION = gql`
  mutation UpdateRead($id: ID!) {
    updateRead(id: $id) {
      data {
        id
        read
      }
    }
  }
`;

export const REMOVE_NOTIFICATION = gql`
  mutation RemoveNotification($id: ID!) {
    removeNotification(id: $id) {
      data {
        id
      }
    }
  }
`;
